import { _ as e, j as i, k as n, l as t, n as o, o as s, p as c, q as l, s as a, d as r, F as d } from "./sharedStyles.js";
import { jsx as p, jsxs as g, Fragment as f } from "react/jsx-runtime";
import { createUseStyles as h } from "react-jss";
import { Tooltip as m } from "@wds/tooltip";
import { Popout as b } from "@wds/popout";
import { IconArrowUp as u } from "@wds/icons";
const v = h(({
  type: e
}) => ({
  suffix: {
    paddingLeft: "8px",
    fontWeight: e.fontWeight.regular
  },
  totals: {
    display: "block",
    fontWeight: e.fontWeight.regular,
    color: "#757575"
  },
  significance: {
    display: "block",
    fontWeight: e.fontWeight.regular,
    color: "#757575"
  }
}));

function y({
  name: e,
  title: i,
  suffix: n,
  totals: t,
  statisticalSignificanceLabel: o,
  className: s
}) {
  const c = v(),
        l = p("span", {
    title: i,
    dangerouslySetInnerHTML: {
      __html: `<span>${e.replace(" - ", " -</span><br/><span>")}</span>`
    }
  });
  return g("th", Object.assign({
    className: s
  }, {
    children: [l, n && p("span", Object.assign({
      className: c.suffix
    }, {
      children: n
    })), t && g("span", Object.assign({
      className: c.totals
    }, {
      children: ["N = ", t]
    })), o && g("span", Object.assign({
      className: c.significance
    }, {
      children: ["(", o, ")"]
    }))]
  }));
}

var j = e,
    x = i,
    C = n,
    O = t,
    N = o,
    S = s,
    w = a,
    k = r,
    z = c.f,
    H = l,
    W = C.Symbol,
    R = W && W.prototype;

if (x && S(W) && (!("description" in R) || void 0 !== W().description)) {
  var L = {},
      M = function () {
    var e = arguments.length < 1 || void 0 === arguments[0] ? void 0 : k(arguments[0]),
        i = w(R, this) ? new W(e) : void 0 === e ? W() : W(e);
    return "" === e && (L[i] = !0), i;
  };

  H(M, W), M.prototype = R, R.constructor = M;
  var T = "Symbol(test)" == String(W("test")),
      B = O(R.valueOf),
      D = O(R.toString),
      I = /^Symbol\((.*)\)[^)]+$/,
      Z = O("".replace),
      F = O("".slice);
  z(R, "description", {
    configurable: !0,
    get: function () {
      var e = B(this);
      if (N(L, e)) return "";
      var i = D(e),
          n = T ? F(i, 7, -1) : Z(i, I, "$1");
      return "" === n ? void 0 : n;
    }
  }), j({
    global: !0,
    constructor: !0,
    forced: !0
  }, {
    Symbol: M
  });
}

const $ = h(() => ({
  button: {
    border: "none",
    background: "none",
    padding: 0,
    height: "20px",
    cursor: "pointer"
  }
}));

function _({
  onClick: e,
  tooltip: i,
  className: n
}) {
  const {
    button: t
  } = $(),
        o = [t];
  return n && o.push(n), p(m, Object.assign({
    text: i
  }, {
    children: p("button", Object.assign({
      className: o.join(" "),
      type: "button",
      onClick: e
    }, {
      children: g("svg", Object.assign({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, {
        children: [p("rect", {
          width: "20",
          height: "20",
          rx: "2",
          fill: "#D0D0D0"
        }), p("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.5625 4.75C4.25184 4.75 4 5.00184 4 5.3125C4 5.62316 4.25184 5.875 4.5625 5.875H15.4375C15.7482 5.875 16 5.62316 16 5.3125C16 5.00184 15.7482 4.75 15.4375 4.75H4.5625ZM4.5625 14.125C4.25184 14.125 4 14.3768 4 14.6875C4 14.9982 4.25184 15.25 4.5625 15.25H15.4375C15.7482 15.25 16 14.9982 16 14.6875C16 14.3768 15.7482 14.125 15.4375 14.125H4.5625ZM4 11.575C4 11.2643 4.25184 11.0125 4.5625 11.0125H15.4375C15.7482 11.0125 16 11.2643 16 11.575C16 11.8857 15.7482 12.1375 15.4375 12.1375H4.5625C4.25184 12.1375 4 11.8857 4 11.575ZM4.5625 7.8625C4.25184 7.8625 4 8.11434 4 8.425C4 8.73566 4.25184 8.9875 4.5625 8.9875H15.4375C15.7482 8.9875 16 8.73566 16 8.425C16 8.11434 15.7482 7.8625 15.4375 7.8625H4.5625Z",
          fill: "#404040"
        })]
      }))
    }))
  }));
}

const q = h(({
  type: e
}) => ({
  colorIdentifier: {
    fontSize: e.fontSize.body,
    marginRight: "16px"
  },
  linkRow: {
    color: "rgb(0, 0, 238)",
    cursor: "pointer",
    textDecoration: "underline"
  },
  iconRow: {
    display: "inline-flex",
    alignItems: "center",
    boxSizing: "border-box"
  },
  icon: {
    marginLeft: "4px"
  }
}));

function A({
  name: e,
  title: i,
  index: n = 0,
  identifier: t,
  color: o,
  event: s,
  fuzzyMatching: c
}) {
  const l = String.fromCharCode(9679),
        a = q(),
        r = g(f, {
    children: ["colors" === t && p("span", Object.assign({
      className: a.colorIdentifier,
      style: {
        color: o || "#8B7DA8"
      }
    }, {
      children: l
    })), "numbers" === t && g("span", {
      children: [n + 1, ". "]
    })]
  }),
        h = g(f, {
    children: ["link" === (null == s ? void 0 : s.type) && p("span", Object.assign({
      className: a.linkRow,
      onClick: null == s ? void 0 : s.handler,
      title: i
    }, {
      children: e
    })), "icon" === (null == s ? void 0 : s.type) && g("div", Object.assign({
      className: a.iconRow
    }, {
      children: [p("span", Object.assign({
        title: i
      }, {
        children: e
      })), p(_, {
        onClick: null == s ? void 0 : s.handler,
        tooltip: null == s ? void 0 : s.description,
        className: a.icon
      })]
    })), !s && p("span", Object.assign({
      title: i
    }, {
      children: e
    }))]
  });
  return g("td", {
    children: [r, c && p(d, Object.assign({
      tooltip: null == c ? void 0 : c.tooltip
    }, {
      children: h
    })), !c && h]
  });
}

const E = h(({
  type: e
}) => ({
  trigger: {
    fontFamily: e.fontFamily.base,
    fontSize: e.fontSize.bodySm
  },
  label: {
    display: "block",
    color: "#9d9d9d",
    marginTop: "4px",
    height: e.fontSize.bodySm
  },
  popoutText: {
    marginLeft: "10px"
  },
  description: {
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "19.94px",
    color: "#222",
    paddingBottom: "8px",
    margin: 0
  },
  confidence: {
    fontWeight: "500",
    color: "#757575",
    margin: 0
  },
  container: {
    display: "flex"
  }
}));

function G({
  label: e,
  description: i,
  confidence: n = "",
  children: t
}) {
  const o = E(),
        s = g("div", Object.assign({
    className: o.trigger
  }, {
    children: [t, p("span", Object.assign({
      className: o.label
    }, {
      children: e
    }))]
  }));
  return "" === e ? s : p(b, Object.assign({
    trigger: s,
    noCloseButton: !0,
    renderTo: document.body,
    size: "md"
  }, {
    children: p(b.Body, {
      children: g("div", Object.assign({
        className: o.container
      }, {
        children: [p(u, {
          title: "arrow up",
          size: "md"
        }), g("div", Object.assign({
          className: o.popoutText
        }, {
          children: [p("p", Object.assign({
            className: o.description
          }, {
            children: i
          })), p("p", Object.assign({
            className: o.confidence
          }, {
            children: n
          }))]
        }))]
      }))
    })
  }));
}

function J({
  value: e,
  className: i,
  statisticalSignificance: n,
  children: t
}) {
  const o = p("span", {
    children: e
  });
  return g("td", Object.assign({
    className: i
  }, {
    children: [n && p(G, Object.assign({
      label: n.label,
      confidence: n.confidenceLevel,
      description: n.description
    }, {
      children: o
    })), !n && o, t]
  }));
}

export { y as T, A as a, J as b };